"use client";
export default function ErrorPage({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main id="main" className="p-10">
      <h1 className="title">We couldn’t load this page</h1>
      <p className="muted mb-5">
        Your session may have expired or your access may have changed. If this
        workspace has not been configured yet, follow the repository setup
        guide.
      </p>
      <button
        className="rounded-lg bg-teal-800 px-5 py-3 text-white"
        onClick={reset}
      >
        Try again
      </button>
      <a className="ml-5" href="/login">
        Sign in again
      </a>
    </main>
  );
}
